module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('h4', {
    staticClass: "text-center",
    attrs: {
      "for": "storage-amount"
    }
  }, [_vm._v(_vm._s(_vm.inputLabel))]), _vm._v(" "), (_vm.inputLabel === '更新安全存量') ? _c('h6', [_vm._v("\n      目前此藥物還有數量 "), _c('strong', [_vm._v(_vm._s(_vm.$store.state.drug.selectedDrugTotalAmount))]), _vm._v(" 在藥櫃中\n    ")]) : _vm._e(), _vm._v(" "), (_vm.inputLabel === '更新安全存量') ? _c('h6', [_vm._v("\n      (總最大庫存數量 "), _c('strong', [_vm._v(_vm._s(_vm.$store.state.drug.selectedDrugTotalMax))]), _vm._v(")\n    ")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storageAmount),
      expression: "storageAmount"
    }],
    ref: "input",
    staticClass: "form-control custom-input",
    attrs: {
      "type": "number",
      "id": "storage-amount",
      "min": "0"
    },
    domProps: {
      "value": (_vm.storageAmount)
    },
    on: {
      "click": function($event) {
        _vm.showPad = true
      },
      "keydown": function($event) {
        _vm.showPad = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.storageAmount = $event.target.value
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showPad) ? _c('NumberInput', {
    attrs: {
      "defaultNumber": _vm.storageAmount
    },
    on: {
      "saveNumber": _vm.saveNumber
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "button-wrap"
  }, [_c('button', {
    staticClass: "btn btn-lg confirm-button",
    on: {
      "click": _vm.setNum
    }
  }, [_vm._v("確認")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25cf6265","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/flowComp/NumberSet.vue
// module id = 1413
// module chunks = 1